var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNurse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 50 52.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4495",
    "data-name": "Group 4495",
    transform: "translate(-124.911 -123.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M135.556,165.176a1.863,1.863,0,0,0,0,3.726h4.9a1.863,1.863,0,0,0,0-3.726Z",
    fill: "#d99d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M127.041,175.806h27.144a6.925,6.925,0,0,1-.692-3v-1.235H129.17v-3a6.752,6.752,0,0,1,4.258-6.3l6.332-2.544a10.493,10.493,0,0,0,13.838.819,6.964,6.964,0,0,1,6.867-5.892h1.98a11.644,11.644,0,0,0,1.108-8.158l-2.661-11.331a14,14,0,0,0-27.459,0l-2.667,11.32a11.708,11.708,0,0,0,3.193,10.99l-2.129.857a10.976,10.976,0,0,0-6.919,10.231v5.125a2.13,2.13,0,0,0,2.129,2.118Zm11.426-36.049a.652.652,0,0,1,.485-.17c2.037.116,6.175-.3,10.979-4.429h0a.641.641,0,0,1,.963.154,11.35,11.35,0,0,0,4.684,4.21.837.837,0,0,1,.447.761l-.106,5.163a10.513,10.513,0,0,1-3.726,7.765.994.994,0,0,0-.357.763v2.154a3.631,3.631,0,0,0,.133.954,6.824,6.824,0,0,1-9.58,0,3.631,3.631,0,0,0,.133-.954v-2.154a.991.991,0,0,0-.356-.757,10.567,10.567,0,0,1-3.476-5.673l-.331-4.194-.058-3.125a.611.611,0,0,1,.164-.468Z",
    fill: "#d99d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M171.664,158.352H160.487a3.249,3.249,0,0,0-3.248,3.248v11.177a3.249,3.249,0,0,0,3.248,3.247h11.177a3.249,3.249,0,0,0,3.247-3.247V161.6A3.249,3.249,0,0,0,171.664,158.352Zm-.591,9.58a.843.843,0,0,1-.842.842h-2.59v2.587a.847.847,0,0,1-.842.842H165.32a.843.843,0,0,1-.842-.842v-2.576h-2.586a.84.84,0,0,1-.842-.84v-1.47a.84.84,0,0,1,.842-.84h2.586v-2.6a.843.843,0,0,1,.842-.819H166.8a.843.843,0,0,1,.842.84v2.566h2.586a.84.84,0,0,1,.84.852Z",
    fill: "#d99d00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurse);
export default __webpack_public_path__ + "static/media/nurse.16c50b43.svg";
export { ForwardRef as ReactComponent };